import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Switch from "@material-ui/core/Switch";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TransferStoreList from "components/List/TransferStoreList";

export default function UserAccessSection({
  allBrands,
  brandFilter,
  onBrandFilterChange,
  accessPersonType,
  onAccessPersonTypeChange,
  visibleAccessTabs,
  profileAccessSummary,
  showBackofficeSwitch,
  backoffice,
  onBackofficeChange,
  disabled,
  filteredPeople,
  pessoasVinculados,
  onPessoasVinculadosChange,
  loadingNaoVinculados,
  loadingLinkedPeople,
  filterStore,
  setFilterStore,
  filterLinkedStore,
  setFilterLinkedStore,
  totalRegistros,
  currentPage,
  setCurrentPage,
  totalPage,
  linkedCurrentPage,
  setLinkedCurrentPage,
  linkedTotalPage,
  linkedTotalRegistros,
  preSelectedPeople,
  setPreSelectedPeople,
  formType,
  skipPersonSelection,
}) {
  const storeSelectAllLabel =
    accessPersonType === "REPRESENTANTE"
      ? "Selecionar todos os representantes"
      : "Selecionar todas as lojas";
  const isEditMode = formType === "edit";
  const hasAccessTabs = visibleAccessTabs?.length > 0;

  return (
    <Box>
      {(profileAccessSummary?.canaisLabels?.length > 0 ||
        profileAccessSummary?.tiposLabels?.length > 0) && (
        <Box mb={2}>
          <Typography variant="body2" gutterBottom>
            Configuração derivada dos perfis selecionados:
          </Typography>
          <Box display="flex" flexWrap="wrap" style={{ gap: 8 }}>
            {profileAccessSummary.canaisLabels.map((label) => (
              <Chip
                key={`canal-${label}`}
                size="small"
                label={`Canal: ${label}`}
              />
            ))}
            {profileAccessSummary.tiposLabels.map((label) => (
              <Chip
                key={`tipo-${label}`}
                size="small"
                color="primary"
                variant="outlined"
                label={`Tipo: ${label}`}
              />
            ))}
          </Box>
        </Box>
      )}

      <FormGroup>
        <FormLabel>Marca (filtro)</FormLabel>
        <RadioGroup
          row
          value={String(brandFilter)}
          onChange={(event) => onBrandFilterChange(event.target.value)}
        >
          <FormControlLabel
            value="TODAS"
            control={<Radio color="primary" disabled={disabled} />}
            label="Todas"
          />
          {allBrands.map((brand) => (
            <FormControlLabel
              key={brand.IdMarca}
              value={String(brand.IdMarca)}
              control={<Radio color="primary" disabled={disabled} />}
              label={brand.Nome}
            />
          ))}
        </RadioGroup>
      </FormGroup>

      {skipPersonSelection ? (
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            Perfis do tipo interno não exigem associação a pessoas. Confirme o
            cadastro.
          </Typography>
        </Box>
      ) : (
        <>
          <FormGroup style={{ marginTop: 16 }}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              gap={1}
            >
              <FormLabel>Tipo Pessoa:</FormLabel>
              {showBackofficeSwitch && (
                <FormControlLabel
                  control={
                    <Switch
                      checked={backoffice}
                      onChange={onBackofficeChange}
                      color="primary"
                      disabled={disabled}
                    />
                  }
                  label="Backoffice"
                  labelPlacement="start"
                  style={{ gap: 10 }}
                />
              )}
            </Box>

            {hasAccessTabs && (
              <TabContext value={accessPersonType}>
                <TabList
                  onChange={(_, value) => onAccessPersonTypeChange(value)}
                  aria-label="Tipo pessoa"
                >
                  {visibleAccessTabs.map((option) => (
                    <Tab
                      key={option.value}
                      label={option.label}
                      value={option.value}
                      disabled={disabled}
                    />
                  ))}
                </TabList>
              </TabContext>
            )}
          </FormGroup>

          {hasAccessTabs && (
            <Box mt={2}>
              <TransferStoreList
                loadingLeft={loadingNaoVinculados}
                loadingRight={loadingLinkedPeople}
                loading={
                  loadingNaoVinculados || loadingLinkedPeople || disabled
                }
                initialLeft={filteredPeople}
                initialRight={pessoasVinculados}
                leftLabel={storeSelectAllLabel}
                rightLabel={storeSelectAllLabel}
                onRightChange={onPessoasVinculadosChange}
                itemTooltipKey="Apelido"
                itemLabelKey="Nome"
                itemExtraLabelKey="Cnpj"
                itemIdKey="Id"
                setFilterStore={setFilterStore}
                totalRegistros={totalRegistros}
                currentPage={Number(currentPage)}
                setCurrentPage={setCurrentPage}
                totalPages={totalPage}
                setFilterLinkedStore={isEditMode ? setFilterLinkedStore : null}
                rightCurrentPage={isEditMode ? Number(linkedCurrentPage) : null}
                setRightCurrentPage={isEditMode ? setLinkedCurrentPage : null}
                rightTotalPages={isEditMode ? linkedTotalPage : null}
                rightTotalRegistros={isEditMode ? linkedTotalRegistros : null}
                checked={preSelectedPeople}
                setChecked={setPreSelectedPeople}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
}
